import { GET_CATEGORY, GET_CATEGORY_SUCCESS, GET_CATEGORY_ERROR, GET_CATEGORY_EMPTY } from './../../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetCategory = (state = initialState, action) => {
  switch (action.type) {
    case GET_CATEGORY:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_CATEGORY_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_CATEGORY_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_CATEGORY_EMPTY:
      state = { ...initialState };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetCategory;
